import { useHiveClient } from '@gitbook/hive-react';

import { useAgent } from './useAgent';

/**
 * Hook to connect to the agent for a change request.
 */
export function useChangeRequestAgent(input: {
    organizationId: string;
    spaceId: string;
    changeRequestId: string;
}) {
    const { organizationId, spaceId, changeRequestId } = input;
    const hiveClient = useHiveClient();
    const agent = useAgent({
        pathname: `/agents/o/${organizationId}/s/${spaceId}/c/${changeRequestId}`,
        getToken: async () => hiveClient.auth.getToken(spaceId),
    });

    return agent;
}
